import React from "react"

const User = ({ userText }) => {
  return (
    <div className="user-message">
      <p>{userText}</p>
    </div>
  )
}

export default User
